import { FORGET_PASSWORD_MUTATION } from "../queries";
import client from "/imports/client/services/apollo/client";

import Debug from "debug";
const debug = Debug("user:pass:forgot");

const forgetPasswordMutate = async (args: { email: string }) => {
  const { email } = args;
  const { errors, data } = await client.mutate({
    mutation: FORGET_PASSWORD_MUTATION,
    variables: {
      email
    }
  });
  debug("forgetPasswordMutate %o", { errors, data });
  // eslint-disable-next-line no-throw-literal
  if (errors?.length) throw errors?.[0];

  return data?.forgetPassword;
};

export default forgetPasswordMutate;
